import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const fragment = window.location.hash;
    const sessionMatch = fragment.match(/session_id=([^&]+)/);
    if (!sessionMatch) {
      navigate("/login", { replace: true });
      return;
    }
    const sessionId = sessionMatch[1];

    (async () => {
      try {
        const { data } = await api.post("/auth/session", null, {
          headers: { "X-Session-ID": sessionId },
        });
        // Also store as bearer token for header-based auth (fallback)
        if (data.session_token) {
          localStorage.setItem("merchify_token", data.session_token);
        }
        await refresh();
        let next = "/account";
        try {
          const stashed = sessionStorage.getItem("post_login_redirect");
          if (stashed && stashed !== "/login" && stashed !== "/signup") {
            next = stashed;
          }
          sessionStorage.removeItem("post_login_redirect");
        } catch { /* ignore */ }
        navigate(next, { replace: true });
      } catch (e) {
        navigate("/login", { replace: true });
      }
    })();
  }, [navigate, refresh]);

  return (
    <div className="min-h-[60vh] flex items-center justify-center">
      <div className="text-overline text-zinc-500">Signing you in…</div>
    </div>
  );
}
